import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmationDialog } from '../../../components/feedback';

/**
 * KYC manual-approve confirmation dialog (AUT-125). Uses the shared
 * `<ConfirmationDialog variant="info">` — no reason field (the action
 * promotes a `manual_review` IDCheck session to `passed`; the audit row
 * captures the actor + timestamp). Brief copy notes the AUT-88 cascade
 * (notification + profile update + payout unlock) so ops understand the
 * downstream effect of the click.
 */
export interface ApproveKycDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ApproveKycDialog = ({
  open,
  loading,
  onConfirm,
  onCancel,
}: ApproveKycDialogProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <ConfirmationDialog
      open={open}
      title={t('inspectors.approveKycDialog.title')}
      description={t('inspectors.approveKycDialog.description')}
      confirmLabel={t('inspectors.approveKycDialog.confirm')}
      variant="info"
      {...(loading !== undefined ? { loading } : {})}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
